import { ApplicationConfig, provideBrowserGlobalErrorListeners, provideZoneChangeDetection, ErrorHandler } from '@angular/core';
import { provideRouter } from '@angular/router';
import { provideHttpClient } from '@angular/common/http';
import { AddinClientService } from '@blackbaud/skyux-lib-addin-client';
import { provideInitialTheme } from '@skyux/theme';

import { routes } from './app.routes';
import { GlobalErrorHandler } from './global-error-handler';

export const appConfig: ApplicationConfig = {
  providers: [
    provideBrowserGlobalErrorListeners(),
    provideZoneChangeDetection({ eventCoalescing: true }),
    provideRouter(routes),
    provideInitialTheme(),
    provideHttpClient(),
    AddinClientService,
    { provide: ErrorHandler, useClass: GlobalErrorHandler }
  ]
};
